import { forwardRef, useState } from "react";
import { LuEye, LuEyeClosed } from "react-icons/lu";

import { Input } from "./Input";
import type { InputProps } from "./Input";

export interface PasswordInputProps extends Omit<InputProps, "type" | "suffix" | "onSuffixClick"> {}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ ...props }, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Input
      ref={ref}
      type={isVisible ? "text" : "password"}
      suffix={isVisible ? <LuEye className="size-4" /> : <LuEyeClosed className="size-4" />}
      onSuffixClick={() => setIsVisible(!isVisible)}
      {...props}
    />
  );
});

PasswordInput.displayName = "PasswordInput";
